import { __extends } from "tslib";
import { deserializeAws_restJson1_1GetVoiceTemplateCommand, serializeAws_restJson1_1GetVoiceTemplateCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetVoiceTemplateCommand = /** @class */ (function (_super) {
    __extends(GetVoiceTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetVoiceTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetVoiceTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetVoiceTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1GetVoiceTemplateCommand(input, context);
    };
    GetVoiceTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1GetVoiceTemplateCommand(output, context);
    };
    return GetVoiceTemplateCommand;
}($Command));
export { GetVoiceTemplateCommand };
//# sourceMappingURL=GetVoiceTemplateCommand.js.map